export default __webpack_public_path__ + "static/3-4-0-0-ab2aae60ddc19f07519c61d16059797d.jpg";